import type { IconSvgObject } from './types';

const HandPointingDown02Icon: IconSvgObject = [
  ["path", { d: "M8 9.5L8 13.5M8 13.5L8 19.75C8 20.7165 8.7835 21.5 9.75 21.5C10.7165 21.5 11.5 20.7165 11.5 19.75L11.5 13.5H16C17.6569 13.5 19 12.1569 19 10.5V5.5C19 3.84314 17.6569 2.5 16 2.5L9.5841 2.5C8.90785 2.5 8.27739 2.84174 7.90829 3.40838L5.98731 6.35738C5.11571 7.68485 5.01657 8.29887 5.00083 8.96984C4.99373 9.27244 5.03246 9.57437 5.11571 9.86537C5.30031 10.5106 5.77679 11.0552 6.7297 12.1442L8 13.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default HandPointingDown02Icon;
